import {createCameraDeviceOverviewReducer} from "./CameraDeviceOverviewReducer";
import {HANDSFREE_CAMERA_SUB_ASSET_TYPE} from "../../../util/Constants";

export const HandsfreeCameraDeviceOverviewReducer = createCameraDeviceOverviewReducer(HANDSFREE_CAMERA_SUB_ASSET_TYPE);



// WEBPACK FOOTER //
// ./src/components/devicemanagement/asmldevice/reducer/HandsfreeCameraDeviceOverviewReducer.js